import http from '@/services/rest/rest.service';
import { IAvpPeriod } from '@/entities/avp-periods/avp-period.interface';
import { IPaging } from '@/entities';

export default {
    list(): Promise<IAvpPeriod[]> {
        return http.get('avp-periods');
    }
};
